import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnquirySidebarService {

  private toggleSource = new Subject<boolean>();
  toggle$ = this.toggleSource.asObservable();

  constructor(private http: HttpClient) {

  }

  open() {
    this.toggleSource.next(true);
  }

  close() {
    this.toggleSource.next(false);
  }

  postContactUs(data:any) {
    const url = environment.apiUrl + "api/Account/" + 'ContactUs';
    console.log(url);
    console.log(JSON.stringify(data));
    return this.http.post<any>(url, data)
      .pipe(map(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
       console.log(user);
        return user;
      }));
  }
}
